import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { ConfigService } from '../config/config.service';
import { EndPoints } from 'src/app/configs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpService, private configs: ConfigService) { }




  async getTokenRequest(){
    let params:any = { refreshToken: this.configs.USER_AUTHORISATION.refresh_token }
    await this.http.authPost2(this.configs.PROXIES.userService, EndPoints.refreshToken, params, "").then(res => {

      if (res.erc == 1 && res.data) {
        this.configs.USER_AUTHORISATION.access_token = res.data.token
        this.configs.USER_AUTHORISATION.expiry =  new Date(res.data.expire_at)
      }
    }).catch(err=>{
      // this.logger.log('token request err', err)
    })
  }
}
